import React from "react";
import { PrimaryButton } from "../Common/PrimaryButton";
import { useNavigate } from "react-router-dom";

export const QuizCard = ({
  title,
  caption,
  image,
  description,
  link,
  invert,
  btntext,
}) => {

    const navigate = useNavigate();

    const handleNavigation = () => {
      const userData = localStorage.getItem("userData");
      if (userData) {
        navigate(`/quiz/${link}`);
      } else {
        navigate("/forms");
      }
    };

  return (
    <div>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: invert? "wrap" : "wrap-reverse",
            gap: "50px",
          }}
        >
          {invert && (
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={image}
                alt="Coaching Federation Logo"
              />
            </div>
          )}
          <div
            style={{
              flex: "1 1 300px",
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2",
              }}
              data-aos="fade"
            >
              {title}
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6",
              }}
              data-aos="fade"
            >
              {caption}
            </p>
            <div style={{ marginTop: "20px" }}>
              <PrimaryButton
                label={btntext ? btntext : "Learn More"}
                onClick={handleNavigation}
              />
            </div>
          </div>
          {!invert && (
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={image}
                alt="Coaching Federation Logo"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};